import Controller from '@ember/controller';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import { getHostDomain } from 'frontend-utils/utils/domain-checks';
import ENV from 'lumen/config/environment';
import type { HotelAndMarketServiceWithHotel } from 'lumen/services/hotel-and-market';
import type { EventProperties } from 'lumen/services/usage-analytics';

export default class HotelSettingsController extends Controller {
  @service('hotel-and-market')
  declare hotelAndMarket: HotelAndMarketServiceWithHotel;
  @service declare usageAnalytics: Services['usage-analytics'];

  get channelManagerSettingsUrl(): string {
    const { id } = this.hotelAndMarket.hotel;
    return `${getHostDomain({ frontendGateway: ENV.frontendGateway })}/apigateway/v1/app/channel-management/channelmanager/outgoing?subscription_id=${id}&page=settings-rateplans`;
  }

  get websiteManagerUrl(): string {
    const { id } = this.hotelAndMarket.hotel;
    return `${getHostDomain({ frontendGateway: ENV.frontendGateway })}/website-manager/hotel/${id}/`;
  }

  @action trackSettingsEvent(event: string, properties: EventProperties): void {
    this.usageAnalytics.track(event, properties);
  }
}
